import type { ShootDraft } from './shoot-conflict.js';

const escapeText = (text: string) =>
  text
    .replace(/\\/g, '\\\\')
    .replace(/\r\n|\r|\n/g, '\\n')
    .replace(/;/g, '\\;')
    .replace(/,/g, '\\,');
const utc = (value: string | Date) => new Date(value).toISOString().replace(/[-:]|\.\d{3}/g, '');

// Fold by UTF-8 octets without splitting Cyrillic or other multibyte characters.
function fold(line: string) {
  const encoder = new TextEncoder();
  let part = '';
  let size = 0;
  const parts: string[] = [];
  for (const character of line) {
    const bytes = encoder.encode(character).length;
    if (size + bytes > 75) {
      parts.push(part);
      part = ' ';
      size = 1;
    }
    part += character;
    size += bytes;
  }
  return [...parts, part].join('\r\n');
}

export function shootCalendar(id: string, draft: ShootDraft, now = new Date()) {
  if (!draft.scheduledStartAt || !Number.isFinite(Date.parse(draft.scheduledStartAt))) return null;
  const end = draft.scheduledEndAt;
  return [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Perova Photo//CRM//EN',
    'CALSCALE:GREGORIAN',
    'BEGIN:VEVENT',
    `UID:${escapeText(id)}@perova.photo`,
    `DTSTAMP:${utc(now)}`,
    `DTSTART:${utc(draft.scheduledStartAt)}`,
    ...(end && Date.parse(end) > Date.parse(draft.scheduledStartAt) ? [`DTEND:${utc(end)}`] : []),
    `SUMMARY:${escapeText(draft.title)}`,
    ...(draft.location?.trim() ? [`LOCATION:${escapeText(draft.location.trim())}`] : []),
    ...(draft.requestedPackageTitle
      ? [`DESCRIPTION:${escapeText(draft.requestedPackageTitle)}`]
      : []),
    'END:VEVENT',
    'END:VCALENDAR',
    '',
  ]
    .map(fold)
    .join('\r\n');
}
